import type { CategoryMeta } from "@/types/catalog";

interface FilterGroup {
  key: string;
  title: string;
  options: string[];
}

interface FilterPanelProps {
  category: CategoryMeta;
  groups: FilterGroup[];
  selected: Record<string, string[]>;
  onToggle: (key: string, value: string) => void;
  onReset: () => void;
  open: boolean;
  onToggleOpen: () => void;
  activeCount: number;
}

export default function FilterPanel({
  category,
  groups,
  selected,
  onToggle,
  onReset,
  open,
  onToggleOpen,
  activeCount,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <button
        type="button"
        onClick={onToggleOpen}
        className="flex w-full cursor-pointer items-center justify-between px-4 py-3 lg:cursor-default"
      >
        <span className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-filter-3-line text-primary-600"></i>
          筛选条件
          {activeCount > 0 && (
            <span className="rounded-full bg-accent-500 px-2 py-0.5 text-xs text-background-50">
              {activeCount}
            </span>
          )}
        </span>
        <i className={`ri-arrow-down-s-line text-foreground-400 lg:hidden ${open ? "rotate-180" : ""}`}></i>
      </button>

      <div className={`${open ? "block" : "hidden"} border-t border-background-200 px-4 py-4 lg:block lg:border-t`}>
        <div className="flex items-center justify-between lg:hidden">
          <p className="text-sm text-foreground-600">选择条件后自动刷新结果</p>
          <button
            type="button"
            onClick={onReset}
            className="cursor-pointer whitespace-nowrap text-sm text-primary-600"
          >
            清空
          </button>
        </div>

        <div className="flex flex-col gap-4">
          {groups.map((group) => (
            <div key={group.key} className="flex flex-col gap-2 sm:flex-row sm:items-start">
              <span className="w-16 shrink-0 pt-1 text-sm text-foreground-500">{group.title}</span>
              <div className="flex flex-wrap gap-2">
                {group.options.map((option) => {
                  const active = selected[group.key]?.includes(option);
                  return (
                    <button
                      key={option}
                      type="button"
                      onClick={() => onToggle(group.key, option)}
                      className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-1 text-sm transition-colors ${
                        active
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900"
                      }`}
                    >
                      {option}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}

          <div className="hidden items-center justify-between border-t border-background-200 pt-3 lg:flex">
            <p className="text-xs text-foreground-400">共 {category.name} 频道 · 点击条件即时刷新</p>
            <button
              type="button"
              onClick={onReset}
              className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
            >
              <i className="ri-refresh-line"></i>
              清空筛选
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}